import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import CompanySizeService from "../../../../services/companySizeService";
import {
  UpdateOrganization,
  HEADERS,
  getOrgId,
  getroleName,
  GetOrganization,
  GetGeneralPeferences,
  UpdateGeneralPeference,
  GetCompanyLogo,
  DeactivateAccount,
  DefaultLogo,
} from "../../../api";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import { Link } from "react-router-dom";

function SettingPreferences() {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      organization_name: "",
      industry: "",
      fax: "",
      official_number: "",
      zip_code: "",
      address1: "",
      address2: "",
      city: "",
      country: "",
      company_size: "",
      from_email_display_name: "",
      from_email_address: "",
      show_company_logo: false,
      company_logo_name: "",
      company_logo_status: "",
    },
  });

  const [logoFile, setLogoFile] = useState(null);
  const [logoBinaryData, setLogoBinaryData] = useState(null);
  const showLogo = watch("show_company_logo");
  const [logoFound, setLogoFound] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (showLogo) {
      fetchCompanyLogoDefault();
    } else {
      setLogoFound(false);
      setCompanyLogo(null);
    }
  }, [showLogo]);

  const handleLogoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLogoFile(file);
      setCompanyLogo(URL.createObjectURL(file));
      setLogoFound(true);
    }
  };
  const userRole = getroleName();

  const [generalPreferences, setGeneralPreferences] = useState({});
  const [companySize, setCompanySize] = useState([]);

  useEffect(() => {
    const getGeneralPreferences = async () => {
      const orgId = getOrgId();
      try {
        const requestBody = {
          org_id: orgId,
        };
        const response = await axios.post(
          GetGeneralPeferences,
          JSON.stringify(requestBody),
          { headers: HEADERS }
        );
        if (response.data && response.data.data) {
          setGeneralPreferences(response.data);
        } else {
          console.warn(
            "General Preferences API response data is not in expected format."
          );
          setGeneralPreferences({});
        }
      } catch (error) {
        console.error("Error fetching General Preferences:", error);
        setGeneralPreferences({});
      }
    };

    getGeneralPreferences();
  }, []);
  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = "/login";
  };
  const DeactivateOrganisation = async () => {
    const orgId = getOrgId();
    try {
      const requestBody = {
        org_id: orgId,
      };
      const response = await axios.post(
        DeactivateAccount,
        JSON.stringify(requestBody),
        { headers: HEADERS }
      );
      if (response.data.response_code === "0000") {
        Swal.fire({
          icon: "info",
          title: "Account Deactivated",
          text: "Your account has been successfully deactivated. You will no longer be able to log in or access any services associated with this account. If you wish to reactivate your account in the future, please contact our support team.",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "swal-custom-confirm-btn",
          },
        }).then(() => {
          handleLogout();
        });
      } else {
        Swal.fire("Error", "Failed to deactivate account.", "error");
      }
    } catch (error) {
      console.error("Error", error);
      Swal.fire("Error", "Something went wrong.", "error");
    }
  };

  useEffect(() => {
    const getOrganizationInfo = async () => {
      const orgId = getOrgId();

      try {
        const requestBody = {
          org_id: orgId,
        };

        const response = await axios.post(
          GetOrganization,
          JSON.stringify(requestBody),
          { headers: HEADERS }
        );
        if (
          response.data &&
          Array.isArray(response.data.data) &&
          response.data.data.length > 0
        ) {
          const orgData = response.data.data[0];
          setValue("organization_name", orgData.organization_name || "");
          setValue("industry", orgData.industry || "");
          setValue("fax", orgData.fax || "");
          setValue("official_number", orgData.official_number || "");
          setValue("zip_code", orgData.zip_code || "");
          setValue("address1", orgData.address_1 || "");
          setValue("address2", orgData.address_2 || "");
          setValue("city", orgData.city || "");
          setValue("country", orgData.country || "");
          setValue("company_size", orgData.size_of_company || "");
          if (generalPreferences.data) {
            setValue(
              "from_email_display_name",
              generalPreferences.data.from_email_display_name || ""
            );
            setValue(
              "from_email_address",
              generalPreferences.data.from_email_address || ""
            );
            setValue(
              "show_company_logo",
              !!generalPreferences.data.show_company_logo
            );
            setValue(
              "company_logo_name",
              generalPreferences.data.company_logo_name || ""
            );
            setValue(
              "company_logo_status",
              generalPreferences.data.company_logo_status || ""
            );
          }
        } else {
          console.warn(
            "Organization Info API response data is not in expected format or is empty."
          );
        }
      } catch (error) {
        console.error("Error setting default values:", error);
      }
    };
    getOrganizationInfo();
  }, [setValue, generalPreferences]);

  useEffect(() => {
    const fetchCompanySize = async () => {
      try {
        const companySizeServiceResponse = await CompanySizeService();
        if (
          companySizeServiceResponse.response_code === "0000" &&
          Array.isArray(companySizeServiceResponse.data)
        ) {
          setCompanySize(companySizeServiceResponse.data);
        } else {
          console.warn(
            "Company Size API response data is not an array or has an error code."
          );
          setCompanySize([]);
        }
      } catch (error) {
        console.error("Error fetching company size:", error);
        setCompanySize([]);
      }
    };
    fetchCompanySize();
  }, []);

  const handleDisableClick = async (data) => {
    const orgId = getOrgId();
    try {
      const requestBody = {
        organization_id: orgId,
        organization_name: getValues("organization_name"),
        size_of_company: getValues("company_size"),
        industry: getValues("industry"),
        official_number: getValues("official_number"),
        fax: getValues("fax"),
        address_1: getValues("address1"),
        address_2: getValues("address2"),
        country: getValues("country"),
        zip_code: getValues("zip_code"),
        city: getValues("city"),
      };

      console.log("er", requestBody);
      const result = await Swal.fire({
        title: "Are you sure you want to update changes?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });

      if (result.isConfirmed) {
        try {
          const response = await axios.post(
            UpdateOrganization,
            JSON.stringify(requestBody),
            { headers: HEADERS }
          );
          console.log("asd", response);
          if (response.data.response_code === "0000") {
            Swal.fire({
              icon: "success",
              title: "Updated!",
              text:
                response.data.response_description ||
                "Your changes have been saved.",
              customClass: {
                confirmButton: "swal-custom-confirm-btn",
              },
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Failed!",
              text:
                response.data.response_description ||
                "Failed to update. Please try again.",
              customClass: {
                confirmButton: "swal-custom-confirm-btn",
              },
            });
          }
        } catch (error) {
          console.error("Error updating:", error);
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "An error occurred while updating. Please try again.",
            customClass: {
              confirmButton: "swal-custom-confirm-btn",
            },
          });
        }
      }
    } catch (error) {
      console.error("Error updating:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An unexpected error occurred. Please try again.",
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
        },
      });
    }
  };
  const [companyLogo, setCompanyLogo] = useState(null);

  const fetchCompanyLogo = async () => {
    const orgId = getOrgId();

    try {
      const formData = new FormData();
      formData.append("organization_id", orgId);

      const response = await axios.post(GetCompanyLogo, formData, {
        headers: {
          ...HEADERS,
        },
        responseType: "arraybuffer",
      });

      let isJsonResponse = false;
      let parsedJson;

      try {
        const textDecoder = new TextDecoder("utf-8");
        const responseText = textDecoder.decode(response.data);
        parsedJson = JSON.parse(responseText);
        isJsonResponse = true;
      } catch (e) {}

      if (isJsonResponse && parsedJson?.response_code === "3001") {
        console.warn("No logo found, using fallback.");
        setLogoFound(false);
        setCompanyLogo(null);
        return;
      }

      const blob = new Blob([response.data], { type: "image/png" });
      const fileFromBlob = new File([blob], "company_logo.png", {
        type: "image/png",
      });

      setLogoFound(true);
      setCompanyLogo(URL.createObjectURL(blob));
      setLogoFile(fileFromBlob);
    } catch (error) {
      console.error("Error fetching company logo:", error);
      setLogoFound(false);
      setCompanyLogo(null);
    }
  };
  const fetchCompanyLogoDefault = async () => {
    const orgId = getOrgId();

    try {
      const formData = new FormData();
      formData.append("organization_id", orgId);

      const response = await axios.post(DefaultLogo, formData, {
        headers: HEADERS,
        responseType: "arraybuffer",
      });

      let isJsonResponse = false;
      let parsedJson;

      try {
        const textDecoder = new TextDecoder("utf-8");
        const responseText = textDecoder.decode(response.data);
        parsedJson = JSON.parse(responseText);
        isJsonResponse = true;
      } catch (e) {}

      if (isJsonResponse && parsedJson?.response_code === "3001") {
        console.warn("No logo found.");
        setLogoFound(false);
        setCompanyLogo(null);
        return;
      }

      const blob = new Blob([response.data], { type: "image/png" });
      const fileFromBlob = new File([blob], "company_logo.png", {
        type: "image/png",
      });

      setLogoFound(true);
      setCompanyLogo(URL.createObjectURL(blob));
      setLogoFile(fileFromBlob);
    } catch (error) {
      console.error("Error fetching company logo:", error);
      setLogoFound(false);
      setCompanyLogo(null);
    }
  };

  useEffect(() => {
    if (showLogo) {
      fetchCompanyLogo();
    }
  }, [showLogo]);

  const updateGeneralPreferences = async () => {
    const orgId = getOrgId();
    try {
      const formData = new FormData();
      formData.append("organization_id", orgId);
      formData.append(
        "from_email_address_display",
        getValues("from_email_display_name")
      );
      formData.append(
        "show_company_logo",
        getValues("show_company_logo").toString()
      );

      if (logoFile) {
        formData.append("company_logo", logoFile, logoFile.name);
      }
      console.log("FormData contents:");
      for (let [key, value] of formData.entries()) {
        console.log(`${key}:`, value);
      }

      Swal.fire({
        title: "You want to update general preferences?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Update",
        cancelButtonText: "Cancel",
        reverseButtons: true,
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(
              UpdateGeneralPeference,
              formData,
              {
                headers: {
                  ...HEADERS,
                  "Content-Type": "multipart/form-data",
                },
              }
            );

            if (response.data.response_code === "0000") {
              Swal.fire({
                icon: "success",
                title: "Success",
                text: "General preferences updated!",
                customClass: {
                  confirmButton: "swal-custom-confirm-btn",
                  cancelButton: "swal-custom-cancel-btn",
                },
              }).then(() => {
                window.location.reload();
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Update Failed!",
                text:
                  response.data.response_description ||
                  "An error occurred during update.",
                customClass: {
                  confirmButton: "swal-custom-confirm-btn",
                  cancelButton: "swal-custom-cancel-btn",
                },
              });
            }
          } catch (error) {
            console.error(
              "Error submitting General Preferences update:",
              error
            );
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: "Failed to update General Preferences. Please try again.",
              customClass: {
                confirmButton: "swal-custom-confirm-btn",
                cancelButton: "swal-custom-cancel-btn",
              },
            });
          }
        }
      });
    } catch (error) {
      console.error("Error updating General Preferences:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An unexpected error occurred. Please try again.",
        customClass: {
          confirmButton: "swal-custom-confirm-btn",
          cancelButton: "swal-custom-cancel-btn",
        },
      });
    }
  };

  const [showForms, setShowForms] = useState(true);
  const [showDisable2, setShowDisable2] = useState(false);
  const [activeButton, setActiveButton] = useState("Organization");
  const [isGeneralPreferencesActive, setIsGeneralPreferencesActive] =
    useState(true);
  const [isDisableActive, setIsDisableActive] = useState(false);

  const showFormsSection = () => {
    setShowForms(true);
    setShowDisable2(false);
    setIsDisableActive(false);
    setIsGeneralPreferencesActive(true);
    setActiveButton("Organization");
  };

  const showDisable2Section = () => {
    setShowForms(false);
    setShowDisable2(true);
    setIsDisableActive(false);
    setIsGeneralPreferencesActive(false);
    setActiveButton("General Preferences");
  };

  const handleDeactivate = () => {
    Swal.fire({
      text: "Are you sure you want to deactivate your account? This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Deactivate",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      confirmButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        DeactivateOrganisation();
      }
    });
  };

  return (
    <div className="">
      <div>
        <span className="breadcrumb d-flex gap-2">
          <Link
            className="previou-link text-decoration-none"
            to="/other-setting"
          >
            Other Setting
          </Link>
          <span>/</span>
          <span className="current-link text-decoration-none">Preference</span>
        </span>
      </div>
      <span className="title">Preferences</span>
      <div className="mt-3">
        <button
          className={`button btn-org ${
            activeButton === "Organization" ? "active" : ""
          }`}
          onClick={showFormsSection}
        >
          Organization
        </button>
        <button
          className={`button btn-gnr ${
            activeButton === "General Preferences" ? "active" : ""
          }`}
          onClick={showDisable2Section}
        >
          General Preferences
        </button>
      </div>
      <div className="disable">
        <div className="row">
          <form onSubmit={handleSubmit(handleDisableClick)}>
            {" "}
            <div className={` disable-forms ${showForms ? "" : "d-none"}`}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <h5 className="mt-2">
                      <strong>Basic Information</strong>
                    </h5>

                    <div className="mt-2">
                      <label>Organization Name</label>
                      <input
                        type="text"
                        placeholder="Enter organization name"
                        className="form-control mt-1"
                        {...register("organization_name", { required: true })}
                      />
                    </div>

                    <div className="form-group mt-2">
                      <label>Industry</label>
                      <select
                        className="form-select mt-1"
                        {...register("industry", {
                          required: "Industry is required",
                        })}
                        defaultValue={getValues("industry") || ""} // prefill logic if needed
                      >
                        <option value="">Select Industry</option>
                        <option value="Education">Education</option>
                        <option value="Finance">Finance</option>
                        <option value="Business">Business</option>
                        <option value="Technology">Technology</option>
                        <option value="Healthcare">Healthcare</option>
                      </select>
                      {errors.industry && (
                        <span style={{ color: "red", fontSize: "14px" }}>
                          {errors.industry.message}
                        </span>
                      )}
                    </div>

                    <div className="mt-2">
                      <label>Fax Number</label>
                      <input
                        type="tel"
                        placeholder="Enter fax number"
                        className="form-control mt-1"
                        {...register("fax")}
                      />
                    </div>

                    <div className="mt-2">
                      <label>Official Number</label>
                      <input
                        type="tel"
                        placeholder="Enter telephone number"
                        className="form-control mt-1"
                        {...register("official_number")}
                      />
                    </div>

                    <div className="mt-2">
                      <label>Zip Code</label>
                      <input
                        type="tel"
                        placeholder="Enter zip code"
                        className="form-control mt-1"
                        {...register("zip_code")}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <h5 className="mt-2">
                      <strong>Address</strong>
                    </h5>
                    <div className="mt-2">
                      <label>Address1</label>
                      <input
                        type="text"
                        placeholder="Enter address1"
                        className="form-control mt-1"
                        {...register("address1")}
                      />
                    </div>
                    <div className="mt-2">
                      <label>Address2</label>
                      <input
                        type="text"
                        placeholder="Enter address 2"
                        className="form-control mt-1"
                        {...register("address2")}
                      />
                    </div>
                    <div className="mt-2">
                      <label>City</label>
                      <input
                        type="text"
                        placeholder="Enter city"
                        className="form-control mt-1"
                        {...register("city")}
                      />
                    </div>
                    <div className="mt-2">
                      <label>Country</label>
                      <input
                        type="text"
                        placeholder="Enter country"
                        className="form-control"
                        {...register("country")}
                      />
                    </div>
                    <div hidden>
                      <label>Company Size</label>
                      <select
                        className="form-select mt-1"
                        {...register("company_size", {
                          required: "Please select company size",
                        })}
                      >
                        {companySize && companySize.length > 0 ? (
                          companySize.map((option, index) => (
                            <option
                              key={option.id || `size-${index}`}
                              value={option.id}
                            >
                              {option.size_range}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            Loading company sizes...
                          </option>
                        )}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {isGeneralPreferencesActive && (
              <div className="d-flex gap-3 mt-3 justify-content-end">
                <Link to="/other-setting" style={{ textDecoration: "none" }}>
                  <button
                    style={{ height: "43px", width: "100px" }}
                    className="button justify-content-center d-flex align-items-center"
                  >
                    Cancel
                  </button>
                </Link>
                <button
                  style={{ height: "43px", width: "100px" }}
                  className="button add-button justify-content-center"
                  type="submit"
                >
                  {" "}
                  Update{" "}
                </button>
              </div>
            )}
          </form>
          <form onSubmit={handleSubmit(updateGeneralPreferences)}>
            {" "}
            <div
              className={`disable2 pt-2 disable-forms ${
                showDisable2 ? "" : "d-none"
              }`}
            >
              <div className="row">
                <div className="col-md-6">
                  <h5>
                    <strong>Email Setting</strong>
                  </h5>
                  <div className="mt-2">
                    <label>Email display name</label>
                    <input
                      type="text"
                      placeholder="DK leave request"
                      className="form-control mt-1"
                      {...register("from_email_display_name", {
                        required: "Email display name is required",
                      })}
                    />
                  </div>
                  <div className="mt-2">
                    <label>From email address</label>
                    <input
                      readOnly="true"
                      type="text"
                      placeholder="Enter email address"
                      className="form-control mt-1"
                      {...register("from_email_address", {
                        required: "From email address is required",
                      })}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <h5>
                    <strong>Other Setting</strong>
                  </h5>
                  <div className="mt-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="show-logo-check"
                        {...register("show_company_logo")}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="show-logo-check"
                      >
                        Display company's own logo
                      </label>
                    </div>
                  </div>
                  {showLogo && (
                    <div className="mt-2">
                      <label>Company Logo</label>
                      <div className="d-flex align-items-center">
                        <div className="border rounded p-3 w-100">
                          {companyLogo && (
                            <img
                              src={companyLogo}
                              alt="Company Logo"
                              style={{
                                width: "100%",
                                maxHeight: "100px",
                                objectFit: "contain",
                              }}
                            />
                          )}

                          <input
                            className="form-control mt-2"
                            type="file"
                            id="company-logo"
                            accept="image/*"
                            onChange={handleLogoChange}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {!isGeneralPreferencesActive && !isDisableActive && (
              <div className="d-flex justify-content-end gap-3 mt-3">
                <Link to="/other-setting" style={{ textDecoration: "none" }}>
                  <button
                    style={{ height: "43px", width: "100px" }}
                    className="button justify-content-center d-flex align-items-center"
                  >
                    Cancel
                  </button>
                </Link>
                <button
                  style={{ height: "43px", width: "100px" }}
                  className="button add-button justify-content-center"
                  type="submit"
                >
                  {" "}
                  Update{" "}
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
      {userRole === "root user" && (
        <div className="form-group mt-3 disable">
          <h5 className=" text-danger">
            <strong>Deactivate Organisation</strong>
          </h5>
          <div>
            <span>
              <strong>Note:</strong> You will no longer be able to log in or
              access any services associated with this account. If you wish to
              reactivate your account in the future, please contact our support
              team.
            </span>
          </div>
          <div className="col-md-3 ms-auto mt-2">
            <button className="deactivate rounded" onClick={handleDeactivate}>
              Deactivate
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SettingPreferences;
